<template>
  <v-container>
    <div class="elevation-1 px-5 py-5 mt-3">
      <SimplePageHeader title="Time Management" class="px-4 pr-5 mb-5">
        <template v-slot:right-buttons>
          <ButtonCustomIcon
            v-if="viewMode !== 'month'"
            icon="cloud_download"
            color="primary"
            text="Excel"
            class="hide-on-print"
            @click="handleExportToExcel"
            :block="true"
          />
        </template>
      </SimplePageHeader>
      <v-row
        align="center"
        justify="start"
        class="px-5 mb-2 pb-1"
        no-gutters
      >
        <v-col cols="6" md="3">
          <v-btn
            block
            color="primary"
            class="time-view-toggle-left"
            :outlined="viewMode !== 'week'"
            @click="setViewMode('week')"
          >Week</v-btn>
        </v-col>
        <v-col cols="6" md="3">
          <v-btn
            block
            color="primary"
            class="time-view-toggle-right"
            :outlined="viewMode !== 'month'"
            @click="setViewMode('month')"
          >Month</v-btn>
        </v-col>
      </v-row>
    </div>
    <WeeklyTimeManagement v-if="viewMode === 'week'" ref="weeklyView"></WeeklyTimeManagement>
    <MonthlyTimeManagement v-if="viewMode === 'month'"></MonthlyTimeManagement>
    <BottomSpacer></BottomSpacer>
  </v-container>
</template>

<script>
import { SimplePageHeader } from '@/components/pageComponents'
import { BottomSpacer, ButtonCustomIcon } from '@/components/buttons'
import MonthlyTimeManagement from './MonthlyTimeManagement'
import WeeklyTimeManagement from './WeeklyTimeManagement'

export default {
  components: {
    SimplePageHeader,
    BottomSpacer,
    ButtonCustomIcon,
    MonthlyTimeManagement,
    WeeklyTimeManagement
  },
  data () {
    return {
      viewMode: this.$route.query.viewMode === 'month' ? 'month' : 'week'
    }
  },
  watch: {
    '$route.query.viewMode' (viewMode) {
      const nextViewMode = viewMode === 'month' ? 'month' : 'week'
      if (nextViewMode !== this.viewMode) {
        this.viewMode = nextViewMode
      }
    }
  },
  created () {
    // Default a missing viewMode into the URL without touching any other query
    // params - this only establishes what's already the active view, it isn't
    // a view switch, so it must not strip the other view's filter params.
    if (this.$route.query.viewMode !== this.viewMode) {
      this.$router.replace({ query: { ...this.$route.query, viewMode: this.viewMode } })
    }
  },
  methods: {
    setViewMode (viewMode) {
      if (viewMode === this.viewMode) return
      this.viewMode = viewMode
      const viewQueryKeys = ['dateBegin', 'dateEnd', 'businessEntityId', 'clientId', 'consultantId', 'client', 'consultant', 'assignment', 'month']
      const nextQuery = { ...this.$route.query }
      viewQueryKeys.forEach(key => delete nextQuery[key])
      this.$router.replace({
        query: {
          ...nextQuery,
          viewMode
        }
      })
    },
    handleExportToExcel () {
      if (this.$refs.weeklyView) {
        this.$refs.weeklyView.handleExportToExcel()
      }
    }
  }
}
</script>
<style>
  .time-view-toggle-left {
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }

  .time-view-toggle-right {
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
  }

  .v-data-table-header th.time-management-col,
  .v-data-table__wrapper td.time-management-col,
  .v-data-table-header th.contractor-commission-col {
    padding-left: 1px !important;
    padding-right: 1px !important;
  }

  .contractor-commission-col {
    width: 70px !important;
    max-width: 70px !important;
    padding-left: 1px !important;
    padding-right: 1px !important;
  }
</style>
